import { Box, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';
import { TextRegular } from 'UiKit/typography';

const Loading = () => {
  const { t } = useTranslation('schedule-generate');
  return (
    <Box className={styles['loading__container']}>
      <Spinner color="var(--color-primary70)" size="xl" thickness="4px" speed="0.65s" />
      <TextRegular className={styles['loading__text--description']}>{t('waitingForGeneration')}</TextRegular>
    </Box>
  );
};

export default Loading;
